import { render, staticRenderFns } from "./ModuleColumn.vue?vue&type=template&id=3457c196"
import script from "./ModuleColumn.vue?vue&type=script&lang=js"
export * from "./ModuleColumn.vue?vue&type=script&lang=js"
import style0 from "./ModuleColumn.vue?vue&type=style&index=0&id=3457c196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports